__turbopack_context__.v({
  "bold": "styles-module-scss-module__Qhonkq__bold",
  "child": "styles-module-scss-module__Qhonkq__child",
  "childNavigation": "styles-module-scss-module__Qhonkq__childNavigation",
  "fixed": "styles-module-scss-module__Qhonkq__fixed",
  "highlight": "styles-module-scss-module__Qhonkq__highlight",
  "menuItemGrid": "styles-module-scss-module__Qhonkq__menuItemGrid",
  "menuType": "styles-module-scss-module__Qhonkq__menuType",
  "navigation": "styles-module-scss-module__Qhonkq__navigation",
  "selected": "styles-module-scss-module__Qhonkq__selected",
  "subMenuChild": "styles-module-scss-module__Qhonkq__subMenuChild",
  "subMenuGrid": "styles-module-scss-module__Qhonkq__subMenuGrid",
  "titleName": "styles-module-scss-module__Qhonkq__titleName",
  "titleSubMenu": "styles-module-scss-module__Qhonkq__titleSubMenu",
});
